export default __webpack_public_path__ + "media/images/dashboard_icons/list-d5669f8a8e9f9172674501b8bc77f501.svg";